export default __webpack_public_path__ + "static/media/melos.37e6e24c.png";